export const translations = {
  en: {
    nav: {
      product: "PRODUCT",
      engineering: "ENGINEERING",
      aero: "AERO",
      reviews: "REVIEWS",
      faq: "FAQ",
      buy: "BUY NOW",
    },
    hero: {
      kicker: "CHASSIS-MOUNT / FRONT LIP / BMW M4 F82",
      title1: "RAW GRIP.",
      title2: "REAL PERFORMANCE.",
      sub: "Chassis Mount Front Lip — Lightweight. Functional. Track Ready.",
      cta: "BUY NOW",
      ctaAlt: "VIEW SPECS",
      ticker: "BUILT FOR TRACK — NOT FOR SHOW — BOLT-ON IN 20 MIN — CUT TO ORDER — 9-PLY BIRCH —",
      specWeight: "WEIGHT",
      specMaterial: "MATERIAL",
      specMount: "MOUNT",
      specPrice: "PRICE",
    },
    why: {
      kicker: "SECTION / 01 — WHY WOOD",
      title: "METAL LOOKS GOOD. WOOD WORKS HARDER.",
      sub: "Four honest reasons we cut our front lips from 9-ply marine birch.",
      cards: [
        {
          n: "01",
          t: "Lighter than steel",
          b: "3.6 kg versus 6.5 kg for the equivalent aluminium splitter. Less unsprung mass in front of your front axle means a car that turns in, not a car that pushes.",
        },
        {
          n: "02",
          t: "Absorbs vibration",
          b: "Laminated birch dampens high-frequency chatter from kerbs and road irregularities. Your endplates don't crack, your splitter doesn't ring.",
        },
        {
          n: "03",
          t: "Cheap to replace",
          b: "Carbon splitter costs €900. Ours costs €349. Track curbs don't care which one you chose. When it breaks, you swap a new one on Monday morning.",
        },
        {
          n: "04",
          t: "Functional, not decorative",
          b: "Wood is a tool. We route it, seal it, and mount it to a chassis — not to a Instagram feed. This is the splitter you run, the splitter you break, the splitter you rebuild.",
        },
      ],
    },
    eng: {
      kicker: "SECTION / 02 — ENGINEERING",
      title: "9 LAYERS. ONE JOB.",
      sub: "Marine-grade birch plywood. CNC cut. Vacuum-epoxy sealed.",
      layers: [
        ["09", "UV MATTE VARNISH — 40μ", "Scratch & moisture buffer"],
        ["08", "OUTER BIRCH VENEER — 1.8mm", "Cross-grain torsion"],
        ["07", "CORE LAMINATE — 2.0mm", "Longitudinal stiffness"],
        ["06", "EPOXY LAYER — 0.2mm", "Shear transfer"],
        ["05", "HEART LAMINATE — 2.0mm", "Primary load plane"],
        ["04", "EPOXY LAYER — 0.2mm", "Shear transfer"],
        ["03", "CORE LAMINATE — 2.0mm", "Longitudinal stiffness"],
        ["02", "INNER BIRCH VENEER — 1.8mm", "Cross-grain torsion"],
        ["01", "MARINE EPOXY BASE — 60μ", "Chassis-side seal"],
      ],
      total: "TOTAL THICKNESS",
      totalVal: "15 mm",
    },
    aero: {
      kicker: "SECTION / 03 — AERODYNAMICS",
      title: "LESS LIFT. MORE CONFIDENCE.",
      sub: "Tested in a 1:1 open-jet tunnel against a factory bumper baseline at 120 km/h.",
      stats: [
        { k: "Front lift reduction", v: "-27%" },
        { k: "Balance shift rearward", v: "+4%" },
        { k: "Drag penalty", v: "+3.1%" },
        { k: "Measured at", v: "120 km/h" },
      ],
      caption: "Airflow attaches to the 8° leading edge and separates cleanly along the trailing vortex rail.",
    },
    install: {
      kicker: "SECTION / 04 — INSTALLATION",
      title: "EIGHT BOLTS. ONE LUNCH BREAK.",
      sub: "Chassis-mount means the lip is tied to your frame rails — not to a plastic bumper that will detach on lap two.",
      steps: [
        ["01", "UNBOX", "Remove lip and hardware kit. Confirm: 4 bolts, 4 bushings, 2 rivets."],
        ["02", "ALIGN", "Offer the lip up to the chassis mounts. Use the included drilling template if needed."],
        ["03", "TORQUE", "Bolt to 22 Nm in a star pattern. Do not overtighten the wood."],
        ["04", "DRIVE", "That's it. No zip ties. No silicone. No prayers."],
      ],
    },
    real: {
      kicker: "SECTION / 05 — REAL USE",
      title: "SCARRED. SANDED. STILL RUNNING.",
      sub: "This isn't a concept render. These are customer cars, raw and imperfect.",
    },
    social: {
      kicker: "SECTION / 06 — FIELD LOG",
      title: "TELEMETRY FROM THE PADDOCK.",
      sub: "Raw reviews from drivers who actually use the thing.",
      rating: "Rating",
      post: "Leave a review",
      postTitle: "Leave a review",
      name: "Your name",
      carModel: "Car model",
      reviewTitle: "Headline",
      body: "Body",
      submit: "Submit",
      photoUrl: "Photo URL (optional)",
      pending: "Thanks. Review pending approval.",
      error: "Something broke. Try again.",
      noReviews: "No reviews approved yet — be the first.",
    },
    offer: {
      kicker: "SECTION / 07 — OFFER",
      title: "ONE PRODUCT. ONE PRICE.",
      price: "€349",
      unit: "per unit, cut to order",
      includes: "Ships with: 1 lip, 4× bolts, 4× bushings, 2× rivets. Fits F87 · F80 · F82.",
      stock: "UNITS LEFT IN CURRENT CUT BATCH",
      urgency: "Next batch ships when current lot is cleared.",
      cta: "ORDER YOURS",
      shipping: "+ €25 tracked shipping",
    },
    order: {
      title: "ORDER / PF-{sku}",
      subtitle: "We cut to order. Pay on confirmation — no gateway online yet.",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      car: "Car model + year",
      address: "Shipping address",
      city: "City",
      zip: "ZIP",
      country: "Country",
      qty: "Quantity",
      notes: "Notes (car ride height, drilling needs…)",
      submit: "CHECKOUT → STRIPE",
      submitting: "REDIRECTING…",
      total: "TOTAL",
      success: "Order placed. Check email for confirmation.",
      error: "Could not place order. Try again.",
    },
    faq: {
      kicker: "SECTION / 08 — FAQ",
      title: "QUESTIONS WE ACTUALLY GET.",
    },
    footer: {
      tagline: "Built for track. Not for show.",
      cut: "CUT IN MILAN — SHIPPED GLOBALLY",
      contact: "CONTACT",
      policy: "POLICY",
      admin: "ADMIN",
      rights: "ALL RIGHTS RESERVED",
    },
    lang: {
      toggle: "IT",
    },
    sticky: {
      buy: "BUY NOW",
      price: "€349",
    },
  },
  it: {
    nav: {
      product: "PRODOTTO",
      engineering: "TECNICA",
      aero: "AERO",
      reviews: "RECENSIONI",
      faq: "FAQ",
      buy: "COMPRA",
    },
    hero: {
      kicker: "CHASSIS-MOUNT / FRONT LIP / BMW M4 F82",
      title1: "RAW GRIP.",
      title2: "PERFORMANCE VERE.",
      sub: "Front Lip chassis mount — Leggero. Funzionale. Pronto per la pista.",
      cta: "COMPRA ORA",
      ctaAlt: "SCHEDA TECNICA",
      ticker: "BUILT FOR TRACK — NON PER PARATA — BOLT-ON IN 20 MIN — TAGLIATO SU ORDINE — BETULLA 9-PLY —",
      specWeight: "PESO",
      specMaterial: "MATERIALE",
      specMount: "FISSAGGIO",
      specPrice: "PREZZO",
    },
    why: {
      kicker: "SEZIONE / 01 — PERCHÉ IL LEGNO",
      title: "IL METALLO FA FIGO. IL LEGNO FA FATICA.",
      sub: "Quattro ragioni oneste per cui tagliamo i nostri labbri in betulla 9-ply marina.",
      cards: [
        {
          n: "01",
          t: "Più leggero dell'acciaio",
          b: "3,6 kg contro 6,5 kg per lo splitter in alluminio equivalente. Meno massa non sospesa davanti all'asse anteriore significa un'auto che inserisce, non un'auto che spinge.",
        },
        {
          n: "02",
          t: "Assorbe le vibrazioni",
          b: "La betulla laminata smorza le vibrazioni ad alta frequenza dai cordoli. Gli endplates non si crepano, lo splitter non canta.",
        },
        {
          n: "03",
          t: "Economico da sostituire",
          b: "Uno splitter in carbonio costa 900€. Il nostro 349€. I cordoli non fanno distinzioni. Quando si rompe, lunedì mattina ne monti uno nuovo.",
        },
        {
          n: "04",
          t: "Funzionale, non decorativo",
          b: "Il legno è uno strumento. Lo fresiamo, lo sigilliamo, e lo fissiamo a un telaio — non a un feed Instagram. Questo è lo splitter che usi, che rompi, che ricostruisci.",
        },
      ],
    },
    eng: {
      kicker: "SEZIONE / 02 — INGEGNERIA",
      title: "9 STRATI. UNA FUNZIONE.",
      sub: "Compensato di betulla marina. Taglio CNC. Sigillato sotto vuoto con resina epossidica.",
      layers: [
        ["09", "VERNICE OPACA UV — 40μ", "Buffer graffi e umidità"],
        ["08", "VENEER BETULLA EST. — 1.8mm", "Torsione controvena"],
        ["07", "LAMINATO CORE — 2.0mm", "Rigidità longitudinale"],
        ["06", "STRATO EPOSSIDICO — 0.2mm", "Trasferimento taglio"],
        ["05", "LAMINATO CENTRALE — 2.0mm", "Piano di carico primario"],
        ["04", "STRATO EPOSSIDICO — 0.2mm", "Trasferimento taglio"],
        ["03", "LAMINATO CORE — 2.0mm", "Rigidità longitudinale"],
        ["02", "VENEER BETULLA INT. — 1.8mm", "Torsione controvena"],
        ["01", "BASE EPOSSIDICA MARINA — 60μ", "Sigillo lato telaio"],
      ],
      total: "SPESSORE TOTALE",
      totalVal: "15 mm",
    },
    aero: {
      kicker: "SEZIONE / 03 — AERODINAMICA",
      title: "MENO LIFT. PIÙ FIDUCIA.",
      sub: "Testato in galleria del vento open-jet 1:1 contro paraurti di serie, 120 km/h.",
      stats: [
        { k: "Riduzione lift anteriore", v: "-27%" },
        { k: "Bilanciamento verso retro", v: "+4%" },
        { k: "Penalità di drag", v: "+3,1%" },
        { k: "Misurato a", v: "120 km/h" },
      ],
      caption: "Il flusso si attacca al leading edge a 8° e si stacca pulito lungo la rail posteriore.",
    },
    install: {
      kicker: "SEZIONE / 04 — INSTALLAZIONE",
      title: "QUATTRO BULLONI. DUE RIVETTI. NIENTE FORATURE.",
      sub: "Chassis-mount significa labbro fissato al telaio — non al paraurti di plastica che si stacca al secondo giro.",
      steps: [
        ["01", "APRI", "Togli il labbro e il kit. Conferma presenza: 4 bulloni, 4 boccole, 2 rivetti."],
        ["02", "ALLINEA", "Porta il labbro contro gli attacchi del telaio. Inserisci le boccole tra labbro e telaio."],
        ["03", "SERRA", "Coppia 22 Nm in croce. Inserisci i 2 rivetti sui lati del leading edge."],
        ["04", "GUIDA", "Tutto qui. Niente fascette. Niente silicone. Niente preghiere."],
      ],
    },
    real: {
      kicker: "SEZIONE / 05 — USO REALE",
      title: "GRAFFIATO. CARTEGGIATO. ANCORA VIVO.",
      sub: "Non sono render di concept. Sono auto di clienti, vere e imperfette.",
    },
    social: {
      kicker: "SEZIONE / 06 — LOG DAL CAMPO",
      title: "TELEMETRIA DAL PADDOCK.",
      sub: "Recensioni crude di chi lo usa davvero.",
      rating: "Valutazione",
      post: "Scrivi una recensione",
      postTitle: "Scrivi una recensione",
      name: "Nome",
      carModel: "Modello auto",
      reviewTitle: "Titolo",
      body: "Testo",
      submit: "Invia",
      photoUrl: "URL foto (opzionale)",
      pending: "Grazie. Recensione in attesa di approvazione.",
      error: "Qualcosa non va. Riprova.",
      noReviews: "Nessuna recensione approvata — sii il primo.",
    },
    offer: {
      kicker: "SEZIONE / 07 — OFFERTA",
      title: "UN PRODOTTO. UN PREZZO.",
      price: "€349",
      unit: "a pezzo, tagliato su ordine",
      includes: "Spedizione con: 1 lama, 4 bulloni, 4 boccole, 2 rivetti. Compatibile F87 · F80 · F82.",
      stock: "PEZZI DISPONIBILI NEL LOTTO ATTUALE",
      urgency: "Prossimo lotto spedito a esaurimento dell'attuale.",
      cta: "ORDINA IL TUO",
      shipping: "+ €25 spedizione tracciata",
    },
    order: {
      title: "ORDINE / PF-{sku}",
      subtitle: "Tagliamo su ordine. Pagamento a conferma — nessun gateway online per ora.",
      name: "Nome completo",
      email: "Email",
      phone: "Telefono (opzionale)",
      car: "Modello auto + anno",
      address: "Indirizzo spedizione",
      city: "Città",
      zip: "CAP",
      country: "Paese",
      qty: "Quantità",
      notes: "Note (altezza da terra, forature…)",
      submit: "CHECKOUT → STRIPE",
      submitting: "REDIRECT IN CORSO…",
      total: "TOTALE",
      success: "Ordine confermato. Controlla la mail per conferma.",
      error: "Impossibile inviare. Riprova.",
    },
    faq: {
      kicker: "SEZIONE / 08 — FAQ",
      title: "LE DOMANDE CHE CI FANNO DAVVERO.",
    },
    footer: {
      tagline: "Built for track. Not for show.",
      cut: "TAGLIATO A MILANO — SPEDITO OVUNQUE",
      contact: "CONTATTI",
      policy: "POLICY",
      admin: "ADMIN",
      rights: "TUTTI I DIRITTI RISERVATI",
    },
    lang: {
      toggle: "EN",
    },
    sticky: {
      buy: "COMPRA ORA",
      price: "€349",
    },
  },
};
